import { useQuery } from '@tanstack/react-query';

import { gatewayApiAgent } from 'common/api/apiAgents';
import { UserInfo } from 'common/api-types/director';

const fetchCurrentUser = (): Promise<UserInfo> => {
  return gatewayApiAgent.get(`director/public/v1/current-user`).then((res) => res.data);
};

export const useCurrentUserQuery = () => {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
  });
};
